export default __webpack_public_path__ + "static/media/smartsheet-preview.8d74b8b3.gif";